module.exports = __webpack_public_path__ + "static/tirth-dafa1e9ffd814045a271dbc7fb5e6aae.jpg";